import { PlusOutlined } from '@ant-design/icons';
import { Button, Card } from 'antd';
import React, { useContext, useState } from 'react';
import { AppContext } from '../../../../../AppContext';
import {
  MODULES,
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
} from '../../../../../common/constants';
import { hasPermission } from '../../../../../common/utils';
import Portal from '../../../../../components/Portal';
import BrandTable from '../components/BrandTable';

const Brand = () => {
  const {
    state: { permissions },
  } = useContext(AppContext);
  const [isBrandModalOpen, setIsBrandModalOpen] = useState(false);
  const [brandImages, setBrandImages] = useState([]);

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.BRAND}</div>
      </Portal>
      <Portal portalId="header-right-content">
        {hasPermission(
          PERMISSIONS_KEY?.MASTER_LIST_BRAND,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
            <Button
              className="common-button"
              size="middle"
              icon={<PlusOutlined />}
              onClick={() => {
                setIsBrandModalOpen(true);
              }}
            >
              Add New Brand
            </Button>
          )}
      </Portal>
      <Portal portalId="header-right-content-phones">
        {hasPermission(
          PERMISSIONS_KEY?.MASTER_LIST_BRAND,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
            <Button
              className="common-button"
              size="middle"
              icon={<PlusOutlined />}
              onClick={() => {
                setIsBrandModalOpen(true);
              }}
            >
              Add New Brand
            </Button>
          )}
      </Portal>
      <Card className="full-height-without-nav">
        <BrandTable
          isBrandModalOpen={isBrandModalOpen}
          setIsBrandModalOpen={setIsBrandModalOpen}
          brandImages={brandImages}
          setBrandImages={setBrandImages}
        />
      </Card>
    </>
  );
};

export default Brand;
